import React from 'react'
import { BsGithub } from "react-icons/bs";
import { FaGlobe } from "react-icons/fa";

const ProjectsCard = ({ title, des, src, onClick, githubUrl, liveUrl }) => {
  return (
    <div 
      className="w-full p-4 xl:px-12 h-full xl:py-10 rounded-lg shadow-shadowOne flex flex-col bg-gradient-to-r from-[#000000] to-[#0a0a0a] group hover:bg-gradient-to-b hover:from-[#000000] hover:to-[#000000] transition-colors duration-300 cursor-pointer"
      onClick={onClick}
    >
      <div className="w-full shrink-0 overflow-hidden rounded-lg">
        <img
          className="w-full h-60 object-cover group-hover:scale-110 duration-300 cursor-pointer"
          src={src}
          alt="src"
        />
      </div>
      <div className="w-full mt-5 flex flex-col flex-1 items-start gap-6">
        <div>
          <div className="flex items-center justify-between">
            <h3 className="text-base uppercase text-designColor font-normal">
              {title}
            </h3>
            <div className="flex gap-2">
              {githubUrl && (
                <a
                  href={githubUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  <span className="text-xl w-10 h-10 rounded-full bg-black bg-opacity-25 flex items-center justify-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                    <BsGithub />
                  </span>
                </a>
              )}
              {liveUrl && (
                <a
                  href={liveUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  <span className="text-xl w-10 h-10 rounded-full bg-black bg-opacity-25 flex items-center justify-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                    <FaGlobe />
                  </span>
                </a>
              )}
            </div>
          </div>
          <p className="text-sm tracking-wide mt-3 hover:text-gray-100 duration-300">
            {des}
          </p>
        </div>
      </div>
    </div>
  );
}

export default ProjectsCard